// VER-218: Console session context object + hook, split out of SessionContext.jsx so
// that file exports only the <SessionProvider> component (keeps React Fast Refresh
// happy — a file mixing a component with other exports triggers a full reload).
import { createContext, useContext } from "react";

export const SessionContext = createContext(null);

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error("useSession must be used within <SessionProvider>");
  return ctx;
}
